var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.sheens.length
      ? _c(
          "div",
          {
            staticClass: "flex items-center",
            class:
              _vm.selectorStyle === "alternative"
                ? "alternative-selector-wrapper"
                : "",
          },
          [
            _c(
              "div",
              { staticClass: "hidden lg:block mr-4" },
              [
                _c(
                  "label",
                  {
                    staticClass:
                      "text-xxs text-theme font-semibold uppercase mt-1",
                    attrs: { for: "paint-sheen-select" },
                  },
                  [_vm._v("Sheen")]
                ),
                _vm._v(" "),
                (_vm.infoHeading || _vm.infoText) && _vm.sheens.length > 1
                  ? _c("ButtonInfo", {
                      staticClass: "ml-2px",
                      attrs: {
                        themed: "",
                        heading: _vm.infoHeading,
                        body: _vm.infoText,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.sheens.length > 1
              ? _c("SelectMenu", {
                  staticClass: "hidden lg:block",
                  attrs: {
                    id: "paint-sheen-select",
                    value: _vm.selectedSheen.id,
                    large: "",
                    themed: "",
                    options: _vm.sheenOptions,
                    "open-above": _vm.openAbove,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.changeSheen($event)
                    },
                  },
                })
              : _c("SelectMenuSingle", {
                  staticClass: "hidden lg:block",
                  attrs: {
                    id: "paint-sheen-select",
                    title: _vm.sheens[0].title,
                    large: "",
                    themed: "",
                  },
                }),
            _vm._v(" "),
            _vm.sheens.length > 1
              ? _c("SelectMenuWithLabel", {
                  staticClass: "lg:hidden",
                  attrs: {
                    id: "paint-sheen-select",
                    value: _vm.selectedSheen.id,
                    options: _vm.sheenOptions,
                    label: "Sheen",
                    themed: "",
                    "info-heading": _vm.infoHeading,
                    "info-text": _vm.infoText,
                    "select-style": _vm.selectorStyle,
                    "open-above": _vm.openAbove,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.changeSheen($event)
                    },
                  },
                })
              : _c("SelectMenuWithLabelSingle", {
                  staticClass: "lg:hidden",
                  attrs: {
                    id: "paint-sheen-select-mobile",
                    "select-style": _vm.selectorStyle,
                    label: "Sheen",
                    title: _vm.sheens[0].title,
                    large: "",
                    themed: "",
                  },
                }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.sizes.length
      ? _c(
          "div",
          {
            staticClass: "flex items-center",
            class:
              _vm.selectorStyle === "alternative"
                ? "alternative-selector-wrapper"
                : "",
          },
          [
            _c(
              "label",
              {
                staticClass:
                  "hidden lg:block text-xxs text-theme font-semibold uppercase mr-4 mt-1",
                attrs: { for: "paint-size-select" },
              },
              [_vm._v("Size")]
            ),
            _vm._v(" "),
            _c("SelectMenu", {
              staticClass: "hidden lg:block",
              attrs: {
                id: "paint-size-select",
                required: true,
                value: _vm.selectedSize.id,
                options: _vm.sizeOptions,
                large: "",
                themed: "",
                "open-above": _vm.openAbove,
              },
              on: {
                input: function ($event) {
                  return _vm.changeSize($event)
                },
              },
            }),
            _vm._v(" "),
            _c("SelectMenuWithLabel", {
              staticClass: "lg:hidden",
              attrs: {
                id: "paint-size-select-mobile",
                required: true,
                value: _vm.selectedSize.id,
                options: _vm.sizeOptions,
                "select-style": _vm.selectorStyle,
                label: "Size",
                themed: "",
                "open-above": _vm.openAbove,
              },
              on: {
                input: function ($event) {
                  return _vm.changeSize($event)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }